import React, { Component } from 'react';
import { connect } from "react-redux";

import { ButtonToolbar, Button } from 'react-bootstrap';

class Header extends Component {
    render() {
        let croColor;
        let engColor;
        let attorneyName;
        let address;
        switch(this.props.language){
            case 'Croatian':
                attorneyName = 'odvjetnik mr. sc. Zrinko Zrilić'
                address='Knezova Š. Bribirskih 12, 23000 Zadar, Hrvatska'
                croColor = 'primary'
                engColor = 'default'
                break
            default:
              attorneyName = 'Attorney At Law mr. sc. Zrinko Zrilić'
              address='Knezova S. Bribirskih 12, 23000 Zadar, Croatia'
              croColor = 'default'
              engColor = 'primary'
        }
        return (
            <div>
                <ButtonToolbar className="pull-right">
                    <Button
                        bsSize="xsmall"
                        onClick={() => this.props.updateLanguage('Croatian')}
                        bsStyle={croColor}
                    >
                        Hrvatski
                    </Button>
                    <Button
                        bsSize="xsmall"
                        onClick={() => this.props.updateLanguage('English')}
                        bsStyle={engColor}
                    >
                        English
                     </Button>
                </ButtonToolbar>
                <br />
                <div className="titleFont">
                    <h2>{attorneyName}</h2>
                    <h4>{address}</h4>
                </div>
                <hr className="hrBig" />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { 
      language: state.language 
    };
  };

const mapDispatchToProps = dispatch => {
    return {
        updateLanguage: language => dispatch({ type: 'UPDATE_LANGUAGE', payload: language })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/header/Header.js